var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('home-navigation'), _c('home-notifications'), _c('home-footer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }